var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.contestId === 1 || _vm.contestId === 0)?_c('div',{staticClass:"rules-text-inner",style:({
      background: _vm.bg || 'white',
    })},[_c('div',{style:({
        position: 'relative',
      })},[_c('img',{style:({ width: '19rem' }),attrs:{"src":require("../assets/images/rules/文本art.png"),"alt":""}}),_c('a',{style:({
          position: 'absolute',
          left: '5rem',
          top: '88.2rem',
          width: '5.5rem',
          height: '0.8rem',
          // border: '1px solid teal',
        }),attrs:{"href":"mailto:al.cs2@yo-star.com"}})])]):_vm._e(),(_vm.contestId === 2)?_c('div',{staticClass:"rules-text-inner"},[_c('div',{style:({
        position: 'relative',
      })},[_c('a',{style:({
          position: 'absolute',
          left: '5rem',
          top: '73.5rem',
          width: '5.5rem',
          height: '0.8rem',
          // border: '1px solid teal',
        }),attrs:{"href":"mailto:al.cs2@yo-star.com"}}),_c('img',{style:({ width: '19rem' }),attrs:{"src":require("../assets/images/rules/文本cos.png"),"alt":""}})])]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }